<template>
  <component :is="hero_sunday_component" :section="section" />
</template>

<script>
import ContentHeroSundayDesktop from "@/components/Content/ContentHeroSundayDesktop";
import ContentHeroSundayMobile from "@/components/Content/ContentHeroSundayMobile";

export default {
  components: {
    ContentHeroSundayDesktop,
    ContentHeroSundayMobile
  },

  data: () => ({
    hero_sunday_component: null
  }),

  computed: {
    section() {
      if (!this.$root.data) {
        return null;
      }
      return this.$root.data.selection_sunday_section;
    }
  },

  methods: {
    load_component_content() {
      this.hero_sunday_component = window.matchMedia("(min-width:1025px)")
        .matches
        ? "content-hero-sunday-desktop"
        : "content-hero-sunday-mobile";
    }
  },

  created() {
    this.load_component_content();
    window.addEventListener("resize", () => {
      this.load_component_content();
    });
  }
};
</script>

<style lang="scss" scoped></style>
